import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import styled, { useTheme } from "styled-components";

import { API_CALLS } from "../../../../../API/api_calls";
import { useAppSelector } from "../../../../../redux";
import { ModalContext } from "../../../../Common/Modal";

const ModalFooter = () => {
  const { Color } = useTheme();
  const { footerRef } = useContext(ModalContext);
  const { active_post_id } = useAppSelector((state) => state.postAnalysis);

  const updateCheckPassed = (check_passed: boolean) => {
    API_CALLS.METADATA_POSTS.updateCheckPassed({
      check_passed,
      post_id: active_post_id,
    });
  };

  return (
    <Container ref={footerRef}>
      <ButtonContainer>
        <Components.Button
          color="Primary"
          kind="Primary"
          size="Medium"
          label="Accurate"
          disabled={false}
          onClick={() => updateCheckPassed(true)}
          iconType="Ditto"
          iconPosition="left"
        />
      </ButtonContainer>
      <ButtonContainer>
        <Components.Button
          color="Neutral"
          kind="Secondary"
          size="Medium"
          label="Needs Review"
          disabled={false}
          onClick={() => updateCheckPassed(false)}
          textColor={Color.text["text-emphasize-negative"].value}
        />
      </ButtonContainer>
    </Container>
  );
};

export default ModalFooter;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem
    ${({ theme }) => theme.spacing["spacing-8"].value}rem;
`;

const ButtonContainer = styled.div`
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.negative.subtlest["default-hover"].value};
  button {
    border: none;
    svg {
      min-width: ${({ theme }) =>
        theme.spacing["spacing-8"].value}rem !important;
      min-height: ${({ theme }) =>
        theme.spacing["spacing-8"].value}rem !important;
    }
  }
`;
